
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/OutfitDetails",
      function () {
        return require("private-next-pages/OutfitDetails.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/OutfitDetails"])
      });
    }
  